import { render, staticRenderFns } from "./AttachmentsBlock4.vue?vue&type=template&id=76bc0cf0"
import script from "./AttachmentsBlock4.vue?vue&type=script&lang=js"
export * from "./AttachmentsBlock4.vue?vue&type=script&lang=js"
import style0 from "../attachments-shared.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports